var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticStyle:{"background-color":"transparent"}},_vm._l((_vm.menuItems),function(item,index){return _c('v-list-item',{key:index,attrs:{"to":item.to}},[_c('div',{staticClass:"d-flex align-center justify-center",style:({
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: item.bgColor,
        marginRight: '16px',
        flexShrink: 0
      })},[_c('img',{staticStyle:{"width":"18px","height":"18px","object-fit":"contain","display":"block"},attrs:{"src":item.icon}})]),_c('v-list-item-content',{staticClass:"defaultColor--text"},[_vm._v(" "+_vm._s(item.title)+" ")])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }